module.exports = __webpack_public_path__ + "static/media/menu-black-18dp.c68546b7.svg";